import { useEffect } from 'react';
import { RouterProvider } from 'react-router-dom';
import { router } from './router';
import { ThemeProvider } from './contexts/ThemeContext';
import useAuthStore from './store/authStore';

export default function App() {
  const loadProfile = useAuthStore((s) => s.loadProfile);

  // Restaura a sessão (valida token salvo) no boot.
  useEffect(() => {
    loadProfile();
  }, [loadProfile]);

  return (
    <ThemeProvider>
      <RouterProvider router={router} />
    </ThemeProvider>
  );
}
